import React, { useEffect } from "react";
import { MaganeStockZeroKmBasePage } from "../..";
import { useRenaveContext } from "../../../../hooks";
import { RenaveMenuStepsZeroKmEnum } from "../../../../models";
import { ZeroKmVehicleCheckedInOrganism } from "../../../organisms";

export const VehicleCheckedInZeroKmPage: React.FC = () => {
  const {
    setMenuSelectedStepZeroKmContext,
    menuSelectedStepZeroKmContext,
    menuCurrentStepZeroKmContext,
  } = useRenaveContext();

  useEffect(() => {
    setMenuSelectedStepZeroKmContext(RenaveMenuStepsZeroKmEnum.CheckedInZeroKm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MaganeStockZeroKmBasePage>
      <ZeroKmVehicleCheckedInOrganism
        viewMode={menuSelectedStepZeroKmContext < menuCurrentStepZeroKmContext}
      />
    </MaganeStockZeroKmBasePage>
  );
};
